import React from 'react';
import { RowHeaderTable } from '../../components';
import TablePaymentOrders from '../../components/TablePaymentOrders';

const PaymentOrders: React.FC = () => {
  return (
      <div className="container-body no-padding">
        <RowHeaderTable name="Ordens de Pagamento" />
        <TablePaymentOrders />
    </div>
  );
};

export default PaymentOrders;
